<template lang="pug">
  .v-container(:class="modalClass")
    .h3.u-weight-bold Use a Coupon

    hr.c-hr

    // クーポン登録エリア
    form.v-coupon-form(
    :class="couponLoadingClass",
    @submit.prevent="onSubmitRedeemCouponCode"
    )
      .input--addon-postfix
        input.v-coupon-input.form-ctl.form-ctl--lg(
        type="text",
        v-model="couponCode",
        placeholder="Enter Your Coupon Code",
        :class="{'form-ctl--error': couponsRedeemError}",
        @focus="clearCouponsRedeemError",
        ref="redeemCouponInput"
        )
        .input__addon
          button.v-coupon-button.c-btn.c-btn--primary.c-btn--lg(type="submit", :disabled="!couponCode") Redeem

      p.u-color-red.u-mtxs(
      v-text="couponsRedeemError",
      v-if="couponsRedeemError"
      )

      .u-mts
        p.u-fs-sm.u-color-gray Not applicable to shipping fees. Using TOM Points or a coupon will reduce the amount of TOM Points earned from this order. Only one coupon per order.

    hr.c-hr

    // クーポン一覧エリア
    div
      .h4.u-weight-bold Your Coupons

      .v-coupon-list.u-mtm(:class="couponLoadingClass")
        .c-message.c-message--danger.u-mt0.u-mb0(
        v-text="couponsListError",
        v-if="couponsListError",
        ref="couponListError"
        )

        .c-coupon-list.c-coupon-list--col2.c-coupon-list--col1--sm(
        style="margin-top: -2rem;",
        :class="{'u-ptm': couponsListError}",
        v-if="discounts.length"
        )
          vue-coupon(
          :cart="cart",
          :discount="discount",
          :selected-coupon-id="selectedCouponId",
          :key="discount._id",
          v-for="discount in discounts",
          @change="onSelectedCoupon"
          )
        .c-message.u-mt0(v-else-if="!couponsListError")
          | There are no redeemed coupons.

      // ボタンエリア
      .u-align-right.u-align-center--sm.u-mtm
        button.c-btn.c-btn--primary.c-btn--lg.c-btn--link(type="submit", @click="onCancel") Cancel
        button.c-btn.c-btn--primary.c-btn--lg(type="button", @click="onSubmit", :disabled="loadingCoupons") Continue

    hr.c-hr

    // FAQ
    div
      p
        | Q:
        a.u-mlxs(href="https://otakumode.com/hc/shop/shop_information/shop_information_points_coupons/5885afd47af91fed10f8e316", target="_blank")
          | Can I use a coupon on a product that has a price less than the value of the coupon?
      p
        | Q:
        a.u-mlxs(href="https://otakumode.com/hc/shop/shop_information/shop_information_points_coupons/5885afc3e423c31a117ff600", target="_blank")
          | Can I use more than one coupon per transaction?
</template>

<script>
  import couponComponent from './coupon.vue';

  export default {
    name: 'CheckoutCoupons',

    components: {
      'vue-coupon': couponComponent
    },

    data() {
      return {
        couponsListError: '',
        couponsRedeemError: '',
        loadingCoupons: false,

        couponCode: '',
        selectedCouponId: '',
        selectedCouponData: null,
        initialSelectedCouponId: ''
      };
    },

    watch: {
      couponCode() {
        this.clearCouponsRedeemError();
      }
    },

    computed: {
      cart() {
        return this.$store.getters['cart/current'](
          {populate: ['shipments', 'discount', 'discount.coupon']}
        );
      },

      user() {
        return this.$store.state.user;
      },

      couponLoadingClass() {
        return {
          'c-loading': this.loadingCoupons,
          'c-loading--opacity': this.loadingCoupons
        };
      },

      wishlistId() {
        return this.cart.wishlistId;
      },

      // 現在適用中のディスカウント
      discount() {
        return this.cart.discount;
      },

      // 登録されている全クーポン情報
      discounts() {
        const discounts = this.$store.getters['shoppingDiscounts/list'];
        return discounts.sort((a, b) => {
          return b.created_at.getTime() - a.created_at.getTime();
        });
      },

      // モーダルを開いてから選択しているクーポンに変更があったか否か
      isChangeSelectedCouponId() {
        return !!this.selectedCouponData && (this.selectedCouponId !== this.initialSelectedCouponId);
      },

      modalClass() {
        return {
          'v-container--modal': this.user.is_smart_phone_device
        };
      }
    },

    created() {
      this.$store.dispatch('shoppingDiscounts/fetchAll', {
        wishlistId: this.wishlistId
      })
      .then((res) => {
        this.loadingCoupons = false;

        this.selectedCouponId = res.currentDiscount || '';
        this.initialSelectedCouponId = res.currentDiscount || '';
      })
      .catch((error) => {
        this.couponsListError = error.general || error;
        this.loadingCoupons = false;
      });
    },

    mounted() {
      this.$refs['redeemCouponInput'].focus();
    },

    methods: {
      onCancel() {
        this.$router.push('/checkout/review');
      },

      // モーダル上でContinueが押下された場合の処理
      onSubmit() {
        // 初期状態から選択しているクーポンに変化があった場合のみ
        if (this.isChangeSelectedCouponId) {
          this.couponsListError = '';
          this.loadingCoupons = true;

          this.$store.dispatch('shoppingDiscounts/updateCoupon', {
            wishlistId: this.wishlistId,
            discountId: this.selectedCouponData.discountId,
            isUse: this.selectedCouponData.isUse
          })
          .then(() => {
            this.loadingCoupons = false;
            this.$router.push('/checkout/review');
          })
          .catch((error) => {
            this.couponsListError = error.general || error;
            this.loadingCoupons = false;

            // クーポンが多い場合にエラー表示が見えないのでエラー表示位置まで移動させる
            this.$nextTick(() => {
              this.$refs['couponListError'].scrollIntoView();
            });
          });
        }
        else {
          this.$router.push('/checkout/review');
        }
      },

      // モーダル上でクーポンが選択、または非選択にされた場合の処理
      onSelectedCoupon(selectedCouponData) {
        this.selectedCouponId = selectedCouponData.isUse ? selectedCouponData.discountId : '';
        this.selectedCouponData = selectedCouponData;
      },

      // モーダル上でクーポン登録フォームがSubmitされた場合の処理
      onSubmitRedeemCouponCode() {
        this.couponsRedeemError = '';
        this.loadingCoupons = true;

        this.$store.dispatch('shoppingDiscounts/redeemCoupon', {
          wishlistId: this.wishlistId,
          couponCode: this.couponCode
        })
        .then(() => {
          this.couponCode = '';
          this.loadingCoupons = false;
        })
        .catch((error) => {
          this.couponsRedeemError = error.general || error;
          this.loadingCoupons = false;
        });
      },

      // モーダル上でクーポン登録フォームの入力が更新された場合とフォームにフォーカスが当たった場合にエラーをクリア
      clearCouponsRedeemError() {
        this.couponsRedeemError = '';
      }
    }
  };
</script>

<style scoped>
  .v-container {
    padding: 20px;
  }

  .v-container.v-container--modal {
    padding: 0;
  }

  .v-coupon-form {
    margin: 0 auto;
    max-width: 500px;
  }

  .v-coupon-list {
    min-height: 40px;
  }

  @media (max-width: 479px) {
    .v-coupon-input {
      font-size: 14px;
    }

    .v-coupon-button {
      font-size: 14px;
      padding: 12px;
    }
  }
</style>
